import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

const orderActionMap = {
  OPENING_ORDER: 'open order',
  CLOSING_ORDER: 'close order',
  MODIFY_LIMIT_PRICE: 'modify limit price',
  MODIFY_QUANTITY: 'modify quantity',
};

export function notEnoughBuyingPowerBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        You do not have enough buying power to{' '}
        {parsedStatusObj.orderAction
          ? orderActionMap[parsedStatusObj.orderAction]
          : 'complete action'}
        . {parsedStatusObj.symbol ? '[' + parsedStatusObj.symbol + ']' : ''}
      </Body3>
    </td>
  );
}
